<template>
	<!-- 客户财务信息 -->
	<div>
		<subComponents  ref="showSelectData"></subComponents>
		<el-dialog :title="dataActionBox.boxTitle" :visible.sync="dataActionBox.showStatus" append-to-body top="2rem" width="80%" center>
			<el-form :model="sendDataInfo" v-if="formData" label-width="120px" size="mini">
				<el-row>
					<el-col :span="12" v-for="(formOneValue,formOneKey) in formData.jurconfigform" :key="formOneKey" >
						<el-form-item v-if="formOneValue.isShow==1" :label="formOneValue.showField" :hide-required-asterisk="formOneValue.isRequired == 1 ? true : false" >
							<!-- 系统字段 -->
							<div v-if="formOneValue.isReserved == 0">
								<el-input v-if="formOneValue.entityField == 'cfiAcollect'"   type="number"   v-model="sendDataInfo[formOneValue.entityField]">
								</el-input>
								<el-input v-else-if="formOneValue.entityField == 'cfiApayment'"   type="number"   v-model="sendDataInfo[formOneValue.entityField]">
								</el-input>
								<el-input v-else-if="formOneValue.entityField == 'cfiCreditamount'"   type="number"   v-model="sendDataInfo[formOneValue.entityField]">
								</el-input>
								<el-input v-else-if="formOneValue.entityField == 'cfiScollect'"   type="number"   v-model="sendDataInfo[formOneValue.entityField]">
								</el-input>
								<el-input v-else-if="formOneValue.entityField == 'cfiSpayment'"   type="number"   v-model="sendDataInfo[formOneValue.entityField]">
								</el-input>
								<el-input v-else  v-model.trim="sendDataInfo[formOneValue.entityField]" :maxlength="$store.state.inputLength"></el-input>
								
							</div>
							<!-- 扩展字段 -->
							<div v-if="formOneValue.isReserved == 1">
								
								<!-- 自填 -->
								<el-input v-model.trim="sendDataInfo[formOneValue.entityField]" v-if="formOneValue.operatType == 0"  :maxlength="$store.state.inputLength">
									
								</el-input>
								<!-- 选择数据来源 -->
								<el-input v-model.trim="sendDataInfo[formOneValue.entityField]"  v-else  :maxlength="$store.state.inputLength"  
									@focus="$refs['showSelectData'].openBox(formOneValue.dsmName,formOneValue.entityField,formOneValue.dsmField)">
								</el-input>
							</div>
						</el-form-item>
					</el-col>
				</el-row>
				
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dataActionBox.showStatus = false">取 消</el-button>
				<el-button type="primary" @click="sendDataAction()">确 定</el-button>
			</div>
		</el-dialog>
	</div>
	
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
export default {
	name:'customerFinance',
	// props:['formData'],
    //import引入的组件需要注入到对象中才能使用
    components: {},
    data() {
        //这里存放数据
        return {
			dataActionBox:{
				showStatus:false,
				openMode:'ltr'||'rtl',
				boxTitle:'新增'||'编辑',
				actionType:0, // 0新增，1修改
			},
			sendDataInfo:{
			    "cfiAcollect": 0,
			    "cfiApayment": 0,
			    "cfiCreater": 0,
			    "cfiCreditamount": 0,
			    "cfiCreditperiod": "",
			    "cfiReserves1": "",
			    "cfiReserves2": "",
			    "cfiReserves3": "",
			    "cfiReserves4": "",
			    "cfiReserves5": "",
			    "cfiReserves6": "",
			    "cfiScollect": 0,
			    "cfiSpayment": 0,
			    "cmId": 0
			},
			formData:{},
			
			
        };
    },
    //监听属性 类似于data概念
    computed: {
	},
    //监控data中的数据变化
    watch: {},
    //方法集合
    methods: {
		isShowData(name,value){
			this.sendDataInfo[name] = value
		},
		initActionBox(){
			for(let key in this.sendDataInfo){
				this.sendDataInfo[key]  = ''
			}
			this.sendDataInfo.cfiAcollect  = 0
			this.sendDataInfo.cfiApayment  = 0
			this.sendDataInfo.cfiScollect  = 0
			this.sendDataInfo.cfiSpayment  = 0
			this.dataActionBox.actionType = 0
			this.dataActionBox.showStatus = false
		},
		openBox(cate,formData,mainId,oldData=''){
			this.formData = formData
			this.initActionBox()
			this.sendDataInfo.cmId = mainId
			if(cate == 0){
				this.dataActionBox.boxTitle = '新增客户财务信息'
				this.dataActionBox.openMode = 'ltr'
			}else{
				this.dataActionBox.boxTitle = '编辑客户财务信息'
				this.dataActionBox.openMode = 'rtl'
				for(let key in oldData){
					this.sendDataInfo[key]  = oldData[key]
				}
				
			}
			this.dataActionBox.actionType = cate
			this.dataActionBox.showStatus = true
			
		},
		
	
		
		
		
		// 新增或修改
		async sendDataAction(){
			if(this.sendDataInfo.sbiNumber ==''){
				this.$message({
					message: '请填写账号',
					type: 'error'
				});
				return false
			}
			let sendData = JSON.parse(JSON.stringify(this.sendDataInfo))
			if(this.dataActionBox.actionType==0){
				var responseData =  await this.$http.addCusmasterFinance(sendData)
			}else{
				var responseData =  await this.$http.setCusmasterFinance(sendData)
			}
			if(responseData.status == 200){
				this.$message({
					message: '操作成功',
					type: 'success'
				});
				this.initActionBox()
				this.$parent.getDataList()
				
				
				
			}else{
				this.$message({
					message: responseData.message,
					type: 'error'
				});
			}
		},
		
		
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
    },
    beforeCreate() {
	}, //生命周期 - 创建之前
    beforeMount() {
	}, //生命周期 - 挂载之前
    beforeUpdate() {
	}, //生命周期 - 更新之前
    updated() {
	}, //生命周期 - 更新之后
    beforeDestroy() {
	}, //生命周期 - 销毁之前
    destroyed() {
	}, //生命周期 - 销毁完成
    activated() {
	}, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style>

</style>